// #region  userInfo
export const USER_INFO = 'USER_INFO';
export interface Iitem {
  id: string;
  chineseName: string;
  url: string;
}
export interface ImenuData {
  id: string;
  chineseName: string;
  items: Iitem[];
}

export interface IuserInfo {
  menus: ImenuData[];
  applicationId: string;
  userType: string;
  locationCode: string;
  roleType: string;
  boxNo: string;
  uvFlag: string;
  user: {
    id: string;
    name: string;
  };
}
export interface IsetUserInfo {
  type: typeof USER_INFO;
  payload: IuserInfo;
}

// #endregion
export const WARE_HOUSE_LIST = 'WARE_HOUSE_LIST';
export interface IwarehouseList {
  locationCode: string;
  locationName: string;
  select: boolean;
  chkCode1: string;
  expressName: string;
  boxNo: string;
}

export interface IsetWareHouseList {
  type: typeof WARE_HOUSE_LIST;
  payload: IwarehouseList[];
}

export const LOADING = 'LOADING';
export interface IsetLoading {
  type: typeof LOADING;
  payload: boolean;
}
